/** pa-cart-offers.js — cart drawer upgrade-to-set and free 2 mL sample picker
 *
 *  Every action is a SINGLE /cart/update.js call carrying all of its line
 *  changes at once, so the cart is never briefly missing both the old line and
 *  the new one. update.js keys accept variant IDs, where 0 removes and 1 adds,
 *  which is what makes the swap atomic in one request.
 *
 *  Afterwards we dispatch on:cart:change on document rather than refreshing a
 *  cart-form directly: CartForm listens for it (main.js:1067) and so does
 *  PageHeader (main.js:3957), so the drawer, the cart page and the bag count in
 *  the header all update from one event, on both surfaces.
 *
 *  Cart apps on this store monkey-patch window.fetch (same problem the theme
 *  already works around for form submits in main.js, BuyButtons
 *  .bindMoreOptionsFallback). We use the reference captured by
 *  snippets/pa-pristine-fetch.liquid before content_for_header, and fall back to
 *  borrowing one from a throwaway same-origin iframe realm.
 *
 *  Listeners are document-level and installed once, because this markup lives
 *  inside data-merge nodes and gets replaced wholesale on every cart update.
 */
(function () {
  if (window.__paCartOffersWired) return;
  window.__paCartOffersWired = true;

  var cachedFetch = null;
  var busy = false;
  var fixing = false;
  var fixAttempts = 0;

  function getFetch() {
    if (cachedFetch) return cachedFetch;
    if (typeof window.__paFetch === 'function') {
      cachedFetch = window.__paFetch;
      return cachedFetch;
    }
    try {
      var frame = document.createElement('iframe');
      frame.hidden = true;
      frame.setAttribute('aria-hidden', 'true');
      frame.style.display = 'none';
      document.body.appendChild(frame);
      // Deliberately left in the DOM: removing it tears down the realm the
      // borrowed function belongs to and its promises stop settling.
      cachedFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
    } catch (e) {
      cachedFetch = window.fetch.bind(window);
    }
    return cachedFetch;
  }

  function cartUpdateUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Absolute: relative paths do not resolve dependably from a borrowed realm.
    return window.location.origin + root.replace(/\/$/, '') + '/cart/update.js';
  }

  function postUpdate(updates) {
    return getFetch()(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed');
      return r.json();
    });
  }

  function announceChange() {
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
  }

  function act(updates, btn) {
    if (busy) return;
    busy = true;
    if (btn) btn.disabled = true;
    postUpdate(updates)
      .then(function () {
        busy = false;
        announceChange();
      })
      .catch(function () {
        busy = false;
        // Same posture as the theme's own quantity handler (main.js:1189).
        window.location.reload();
      });
  }

  /* Self-heal: clear duplicate samples, trim a sample that somehow gained
     quantity, and drop a sample orphaned by removing the last real item.
     Liquid works out what needs doing and writes it onto a child element, since
     a merge never updates the merge node's own attributes.

     Only ever driven by on:cart:after-merge, which fires once the DOM has
     actually been re-rendered. Reacting to on:cart:change instead would re-read
     the pre-merge DOM and fire the same correction again. The attempt counter
     is a backstop in case the server will not accept the fix. */
  function reconcile() {
    if (busy || fixing) return;
    var state = document.querySelector('[data-pa-state]');
    if (!state) return;
    var drop = (state.getAttribute('data-drop') || '').split(',').filter(Boolean);
    var trim = state.getAttribute('data-trim') || '';
    if (!drop.length && !trim) {
      fixAttempts = 0;
      return;
    }
    if (fixAttempts >= 2) return;
    fixAttempts += 1;

    var updates = {};
    drop.forEach(function (id) { updates[id] = 0; });
    if (trim) updates[trim] = 1;

    fixing = true;
    postUpdate(updates)
      .then(function () {
        fixing = false;
        announceChange();
      })
      .catch(function () { fixing = false; });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;

    var upgrade = e.target.closest('[data-pa-upgrade]');
    if (upgrade) {
      e.preventDefault();
      var from = upgrade.getAttribute('data-from');
      var to = upgrade.getAttribute('data-to');
      if (!from || !to) return;
      var swap = {};
      swap[from] = 0;
      swap[to] = 1;
      act(swap, upgrade);
      return;
    }

    var chip = e.target.closest('[data-pa-sample]');
    if (chip) {
      e.preventDefault();
      var target = chip.getAttribute('data-to');
      var current = chip.getAttribute('data-current') || '';
      if (!target) return;
      var pick = {};
      // Clearing the old pick and adding the new one travel in the same
      // request, so the bag can never hold two samples.
      if (current) pick[current] = 0;
      if (current !== target) pick[target] = 1;
      act(pick, chip);
    }
  });

  document.addEventListener('on:cart:after-merge', reconcile);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
